module.exports = __webpack_public_path__ + "static/mapa-01-52da8c9b57daad01480610b205160d9c.svg";